const defaultCenters = [
  { brand: 'as', center: { lat: 43.7615714, lng: -79.2921276 } },
  { brand: 'dp', center: { lat: 45.4965782, lng: -73.5591249 } },
  { brand: 'se', center: { lat: 51.0553635, lng: -114.0186927 } },
];
export default defaultCenters;
